export { Tooltip } from './tooltip';

export type { TooltipStylesNames } from './tooltip.types';
export type { TooltipStylesParams } from './tooltip.styles';
export type { TooltipProps } from './tooltip';
